import { ESeoBanStatus } from '.';

export enum EUserUnavailableReason {
  NOT_FOUND = 'not_found',
  SEO_BAN_PRIVATE = 'seo_ban_private',
  SEO_BAN_UNDER_AGE = 'seo_ban_under_age',
  SEO_BAN_UNKNOWN = 'seo_ban_unknown',
  SERVER_ERROR = 'server_error',
}

export const SEOBanReasonMap: Record<ESeoBanStatus, EUserUnavailableReason> = {
  [ESeoBanStatus.Unknown]: EUserUnavailableReason.SEO_BAN_UNKNOWN,
  [ESeoBanStatus.Private]: EUserUnavailableReason.SEO_BAN_PRIVATE,
  [ESeoBanStatus.UnderAge]: EUserUnavailableReason.SEO_BAN_UNDER_AGE,
};

export interface IUserUnavailableDetail {
  userId: string;
  unavailableReason: EUserUnavailableReason;
  seoBan?: ESeoBanStatus;
}
